import { render, staticRenderFns } from "./MiniTCDCTable.vue?vue&type=template&id=cc08cb2c&scoped=true"
import script from "./MiniTCDCTable.vue?vue&type=script&lang=js"
export * from "./MiniTCDCTable.vue?vue&type=script&lang=js"
import style0 from "./MiniTCDCTable.vue?vue&type=style&index=0&id=cc08cb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc08cb2c",
  null
  
)

export default component.exports